import * as React from 'react';
import SecondaryHeaderText from '../../text/SecondaryHeaderText';

const PageTitle = () => (
  <SecondaryHeaderText>Portfolios for sale</SecondaryHeaderText>
);

export default PageTitle;